import React, { useState, useRef, useEffect, useContext } from "react";
import Header from "../Header/header";
import { IoFilterSharp } from "react-icons/io5";
import { FaFilePdf } from "react-icons/fa";
import { Dropdown, Table, Button } from "react-bootstrap";
import { FaChevronDown, FaEye } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { FaCirclePlus } from "react-icons/fa6";
import Search_vendor_popup from "./search_vendor_popup";
import pdf_img from "../images/pdf_downlaod.png";
import random_pdf from "../images/dummy-pdf_2.pdf";
import pdfimage from "../images/pdf_downlaod.png";
import { IconButton, Dialog, DialogTitle, DialogContent, TableHead, TableRow, TableCell, TableBody, DialogActions, Typography } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import Chip from "@mui/material/Chip";
import {
  fetchBatchInvoiceData,
  updateBatchInvoiceStatus,
  updateBatchFinanceStatus,
  BASE_URL,
  fetchVendorSuggestions,
} from "../../api/api";
import { AuthContext } from "../../context/AuthContext";
import { Circles } from "react-loader-spinner";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import GlobalSearchhook from "./GlobalSearchhook";
import { statusColor } from "../../utils/statusColor";

function Review_batches() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { vendorId = "", isExcelUpload = false } = state || {}; // Define vendorId and isExcelUpload from navigation state
  const serviceProviderName = localStorage.getItem("ServiceProviderName");
  const { user } = useContext(AuthContext);

  const [invoicesData, setInvoicesData] = useState([]);
  const [vendorSearch, setVendorSearch] = useState("");
  const [srnSearch, setSrnSearch] = useState("");
  const [searchInvoiceNo, setSeachInvoiceNo] = useState("");
  const [batchSearch, setBatchSearch] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showHoldModal, setShowHoldModal] = useState(false);
  const [infoMessage, setInfoMessage] = useState("");

  const itemsPerPage = 10;
  const dateInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [aaSearchResult, setAaSearchResult] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [aaNumberSearch, setAaNumberSearch] = useState("");
  const vendorList = Array.isArray(invoicesData)
    ? invoicesData.map(({ vendorName, srnNo }) => ({ vendorName, srnNo }))
    : [];
  const { handleSearch, searchText, setSearchText } = GlobalSearchhook()
  const handleIconClick = () => {
    dateInputRef.current?.setFocus();
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleAASearch = async () => {
    if (!aaNumberSearch.trim()) return;

    try {
      const response = await fetch(`${BASE_URL}/GetBatchDataByAANumber`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ aaNo: aaNumberSearch }),
      });

      const result = await response.json();

      if (result && result.length > 0) {
        setAaSearchResult(result);
        setOpenPopup(true);
      } else {
        setAaSearchResult([]);
        setOpenPopup(false);
      }
    } catch (error) {
      console.error("Error fetching AA batch:", error);
      setAaSearchResult([]);
      setOpenPopup(false);
    }
  };

  const filteredInvoices = Array.isArray(invoicesData)
    ? invoicesData.filter((inv) => {
      const creationDateObj = inv.batchCreationDate
        ? new Date(inv.batchCreationDate)
        : null;

      const vendorName = inv.vendorName?.toString().toLowerCase() || "";
      const srnNo = inv.srnNo?.toString().toLowerCase() || "";
      const batchNo = inv.batchNo?.toString().toLowerCase() || "";
      const financeStatus = inv.financeStatus?.toString().toLowerCase() || "";
      const invoiceNumber = inv.invoiceNo?.toString().toLowerCase() || "";

      const vendorMatch = vendorName.includes(vendorSearch.toLowerCase());
      const srnMatch = srnNo.includes(srnSearch.toLowerCase());
      const batchMatch = batchNo.includes(batchSearch.toLowerCase());
      const invoiceNoMatch = invoiceNumber.includes(
        searchInvoiceNo.toLowerCase()
      );

      const dateMatch = selectedDate
        ? creationDateObj &&
        creationDateObj.toDateString() === selectedDate.toDateString()
        : true;

      const statusMatch =
        selectedStatus && selectedStatus !== "All"
          ? financeStatus === selectedStatus.toLowerCase()
          : true;

      // Filter by serviceProviderName matching vendorName (network roles see all data)
      const isNetworkRole = user?.role === "NetworkAdmin" || user?.role === "NetworkSubAdmin" || user?.role === "Finance";
      const serviceProviderMatch = isNetworkRole
        ? true
        : (serviceProviderName ? vendorName === serviceProviderName.toLowerCase() : true);

      // Only batches whose invoice status is Ready For Billing or Re-Assigned are visible
      const statusVal = inv.invoiceStatus?.toString().toLowerCase().trim() || "";
      const isAllowedInvoiceStatus = statusVal === "ready for billing" || statusVal === "re-assigned";

      return (
        vendorMatch &&
        srnMatch &&
        batchMatch &&
        dateMatch &&
        statusMatch &&
        invoiceNoMatch &&
        serviceProviderMatch &&
        isAllowedInvoiceStatus
      );
    })
    : [];

  useEffect(() => {
    setCurrentPage(1);
  }, [
    vendorSearch,
    srnSearch,
    batchSearch,
    selectedDate,
    selectedStatus,
    searchInvoiceNo,
  ]);

  // const dataToRender = aaSearchResult ? [aaSearchResult] : filteredInvoices;
  const totalPages = Math.ceil(filteredInvoices.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInvoices = filteredInvoices.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  // const currentInvoices = dataToRender.slice(indexOfFirstItem, indexOfLastItem);
  console.log(currentInvoices, 'currentnnttn')

  const handleInvoiceStatusChange = async (index, newStatus) => {
    const globalIndex = indexOfFirstItem + index;
    const selectedInvoice = invoicesData[globalIndex];
    const batchNo = selectedInvoice?.batchNo;

    try {
      const reason = newStatus === "Rejected" ? "Some rejection reason" : "";
      const response = await updateBatchInvoiceStatus({
        batchNo,
        status: newStatus,
        reason,
      });

      setInvoicesData((prev) =>
        prev.map((item, i) =>
          i === globalIndex
            ? {
              ...item,
              invoiceStatus: newStatus,
              financeStatus: newStatus === "Approved" ? "Submitted" : "",
            }
            : item
        )
      );

      toast.success("Invoice status updated successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (err) {
      toast.error("Failed to update invoice status.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const handleFinanceStatusChange = async (index, newStatus) => {
    const globalIndex = indexOfFirstItem + index;
    const selectedInvoice = invoicesData[globalIndex];
    const batchNo = selectedInvoice?.batchNo;

    try {
      const reason = newStatus === "Rejected" ? "Finance rejected" : "";
      const response = await updateBatchFinanceStatus({
        batchNo,
        status: newStatus,
        reason,
      });

      setInvoicesData((prev) =>
        prev.map((item, i) =>
          i === globalIndex
            ? {
              ...item,
              financeStatus: newStatus,
              invoiceStatus:
                newStatus !== "Approved" ? "Hold" : item.invoiceStatus,
            }
            : item
        )
      );

      toast.success("Finance status updated successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (err) {
      toast.error("Failed to update finance status.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const data = await fetchBatchInvoiceData();
        if (Array.isArray(data.dataItems || [])) {
          setInvoicesData(data.dataItems || []);
        } else {
          setInvoicesData([]);
        }
      } catch (err) {
        console.error("Failed to load invoice data", err);
        setInvoicesData([]);
        // toast.error("Failed to load invoice data.", {
        //   position: "top-right",
        //   autoClose: 3000,
        // });
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, []);

  const totalGrossAmount = invoicesData.reduce(
    (total, invoice) => total + (parseFloat(invoice.grossAmount) || 0),
    0
  );

  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };



  const handleNewInvoiceClick = async () => {
    // If logged in user is a ServiceProvider, auto-fetch their provider and navigate
    if (user && user.role === "ServiceProvider") {
      const vendor = localStorage.getItem("ServiceProviderName")
      console.log(vendor, 'usernfnnfnf')
      try {
        setLoading(true);
        const res = await fetchVendorSuggestions(vendor || "");
        if (res?.status === true && Array.isArray(res.dataItems) && res.dataItems.length > 0) {
          const provider = res.dataItems[0];
          const vendorName = provider.serviceProviderName || "";
          const vendorId = provider.id || null;
          const isgstRegistered = provider.gstRegistered || false;
          navigate("/vendor-name", {
            state: { vendorName, vendorId, isgstRegistered },
          });
        } else {
          toast.error("No service provider found for this vendor.");
        }
      } catch (err) {
        console.error("Error fetching provider for vendor:", err);
        toast.error("Failed to fetch provider details.");
      } finally {
        setLoading(false);
      }
    } else {
      setShowHoldModal(true);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      console.log("Selected PDF:", file.name);
    } else {
      toast.error("Please select a valid PDF file.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedInvoices = [...currentInvoices].sort((a, b) => {
    if (!sortConfig.key) return 0;

    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];

    if (aValue === undefined || bValue === undefined) return 0;

    const aStr = typeof aValue === "string" ? aValue.toLowerCase() : aValue;
    const bStr = typeof bValue === "string" ? bValue.toLowerCase() : bValue;

    if (aStr < bStr) return sortConfig.direction === "asc" ? -1 : 1;
    if (aStr > bStr) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });
  console.log(sortedInvoices, 'djdjdjdjd')
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${BASE_URL}/GetStillNotClosedCases`);
        const data = await res.json();

        if (data?.resultMessage) {
          setInfoMessage(data.resultMessage);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);


  return (
    <div
      className="container py-4"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <ToastContainer />
      <div className="container mt-4">
        <div className="netwrok_table_main_content">
          <div
            className="table-container mt-3"
            style={{ overflowX: "auto", width: "100%" }}
          >
            <div className="d-flex justify-content-between network_filter_div">
              <h5 className="fw-bold m-0">Invoice</h5>
              <button
                className="btn btn-primary d-flex align-items-center"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
                onClick={handleNewInvoiceClick}
              >
                <FaCirclePlus className="me-2" />
                New Invoice
              </button>
            </div>
            <div className="d-flex justify-content-between network_filter_div">
              <div className="d-flex justify-content-between align-items-center all_search_input">
                <div
                  className="review_batch_seach input-group"
                  style={{ maxWidth: "280px" }}
                >
                  <div className="fa_search_main">
                    <span className="input-group-text bg-light fasearch">
                      <FaSearch className="text-muted" />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control bg-light border-start-0"
                    placeholder="Search by Vendor Name"
                    value={vendorSearch}
                    onChange={(e) => setVendorSearch(e.target.value)}
                    style={{ borderLeft: "none", boxShadow: "none" }}
                  />
                </div>
                <div
                  className="review_batch_seach input-group"
                  style={{ maxWidth: "240px" }}
                >
                  <div className="fa_search_main">
                    <span className="input-group-text bg-light fasearch">
                      <FaSearch className="text-muted" />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control bg-light border-start-0"
                    placeholder="Search by Invoice No"
                    value={searchInvoiceNo}
                    onChange={(e) => setSeachInvoiceNo(e.target.value)}
                    style={{ borderLeft: "none", boxShadow: "none" }}
                  />
                </div>
                <div
                  className="review_batch_seach input-group"
                  style={{ maxWidth: "240px" }}
                >
                  <div className="fa_search_main">
                    <span className="input-group-text bg-light fasearch">
                      <FaSearch className="text-muted" />
                    </span>
                  </div>
                  <input
                    type="number"
                    className="form-control bg-light border-start-0"
                    placeholder="Search by Batch No"
                    value={batchSearch}
                    onChange={(e) => setBatchSearch(e.target.value)}
                    style={{ borderLeft: "none", boxShadow: "none" }}
                  />
                </div>
                <div
                  className="review_batch_seach input-group"
                  style={{ maxWidth: "240px", marginRight: "10px" }}
                >
                  <div className="fa_search_main">
                    <span className="input-group-text bg-light fasearch">
                      <FaSearch className="text-muted" />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control bg-light border-start-0"
                    placeholder="global Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    style={{ borderLeft: "none", boxShadow: "none" }}
                  />

                </div>
              </div>

              {/* <div className="d-flex justify-content-between all_search_input">
                <div
                  className="custom_date_wrapper review_batch_seach"
                  style={{ maxWidth: "240px" }}
                >
                  <DatePicker
                    ref={dateInputRef}
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    className="custom-date-input"
                  />
                  <span className="calendar-icon" onClick={handleIconClick}>
                    <FaRegCalendarAlt />
                  </span>
                </div>
                <div
                  className="input-group review_batch_status"
                  style={{ maxWidth: "240px" }}
                >
                </div>
              </div> */}
            </div>
            <div>
              {infoMessage && (
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#6c757d",
                  fontStyle: "italic",
                  fontSize: "14px",
                  marginBottom: "10px"
                }}>
                  <InfoOutlinedIcon fontSize="small" style={{ marginRight: "6px", color: "#0d6efd" }} />
                  {infoMessage}
                </div>
              )}
            </div>
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "200px" }}
              >
                <Circles
                  height="60"
                  width="60"
                  color="#FE850E"
                  ariaLabel="circles-loading"
                  visible={true}
                />
              </div>
            ) : (
              <div className="table-responsive mt-3">
                <Table
                  className="bg-white text-center border-0 network_table"
                  style={{ width: "100%", borderSpacing: 0, fontSize: "13px" }}
                >
                  <thead style={{ backgroundColor: "#EEF4FF", fontSize: "13px" }}>
                    <tr className="text-dark fw-semibold table_th_border">
                      <th className="border-start" style={{ whiteSpace: "nowrap" }}>View</th>
                      <th style={{ whiteSpace: "nowrap" }}>Log</th>
                      <th onClick={() => handleSort("batchNo")} style={{ cursor: "pointer" }}>
                        Batch No {sortConfig.key === "batchNo" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th>

                      <th onClick={() => handleSort("vendorName")} style={{ cursor: "pointer" }}>
                        Vendor Name {sortConfig.key === "vendorName" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th>

                      {/* <th onClick={() => handleSort("createdDate")} style={{ cursor: "pointer" }}>
                        Batch Creation Date {sortConfig.key === "createdDate" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th> */}

                      {/* <th onClick={() => handleSort("closureDate")} style={{ cursor: "pointer" }}>
                        Batch Closure Date {sortConfig.key === "closureDate" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th> */}

                      <th onClick={() => handleSort("invoiceNo")} style={{ cursor: "pointer" }}>
                        Invoice No {sortConfig.key === "invoiceNo" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th>

                      <th onClick={() => handleSort("invoiceDate")} style={{ cursor: "pointer" }}>
                        Invoice Date {sortConfig.key === "invoiceDate" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th>

                      <th onClick={() => handleSort("invoiceAmount")} style={{ cursor: "pointer" }}>
                        Invoice Amount {sortConfig.key === "invoiceAmount" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th>

                      <th onClick={() => handleSort("totalRepairCharges")} style={{ cursor: "pointer" }}>
                        Total Repair Charges {sortConfig.key === "totalRepairCharges" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th>

                      <th onClick={() => handleSort("totalServiceCharges")} style={{ cursor: "pointer" }}>
                        Total Service Charges {sortConfig.key === "totalServiceCharges" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th>

                      <th onClick={() => handleSort("gst")} style={{ cursor: "pointer" }}>
                        GST {sortConfig.key === "gst" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th>

                      <th onClick={() => handleSort("finalAmount")} style={{ cursor: "pointer" }}>
                        Final Amount {sortConfig.key === "finalAmount" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th>

                      <th onClick={() => handleSort("invoiceStatus")} style={{ cursor: "pointer" }}>
                        Invoice Status {sortConfig.key === "invoiceStatus" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
                      </th>

                      {/* <th>Upload File</th>
                      <th>Actions</th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {sortedInvoices.map((invoice, index) => (
                      <tr
                        key={index}
                        className="text-center border-bottom network_td_item"
                      >
                        <td className="border-start align-middle">
                          <IconButton>
                            <FaEye
                              size={20}
                              className="text-purple review_fa_eye"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                console.log("Clicked invoice row:", invoice);
                                const selectedBatchData = {
                                  aaNo: invoice.aaNo || "",
                                  invoice: invoice.invoice || "",
                                  imeiNo: invoice.imeiNo || "",
                                  creationDate: invoice.creationDate || new Date().toLocaleDateString("en-GB"),
                                  closureDate: invoice.closureDate || "",
                                  customerName: invoice.customerName || "",
                                  serviceType: invoice.serviceType || "",
                                  brand: invoice.brand || "",
                                  makeModel: invoice.makeModel || "",
                                  repairCharges: invoice.repairCharges || "",
                                  serviceCharges: invoice.serviceCharges || "",
                                  total: invoice.total || "",
                                  invoiceStatus: invoice.invoiceStatus || "",
                                  sellingPartner: invoice.sellingPartner || "",
                                  batchNo: invoice.batchNo || "",
                                  vendorName: invoice.vendorName || "",
                                  remarks: invoice.remarks || "",
                                  caseCount: invoice.caseCount || "",
                                  invoiceNo: invoice.invoiceNo || "",
                                  invoiceDate: invoice.invoiceDate || "",
                                  invoiceAmount: invoice.invoiceAmount || "",
                                  remarkFile: invoice.remarkFile || "",
                                  gst: invoice.gst || "",

                                };
                                navigate("/ReviewBatchPage", {
                                  state: {
                                    selectedBatchData,
                                    vendorId,
                                    isExcelUpload,
                                  },
                                });
                              }}
                            />
                          </IconButton>
                        </td>
                        <td className="align-middle">
                          <IconButton onClick={() => navigate(`/logs/${invoice.batchNo}`)}>
                            <DescriptionIcon fontSize="medium" className="text-blue-600 cursor-pointer" />
                          </IconButton>
                        </td>
                        <td className="align-middle">
                          {invoice.batchNo ?? "--"}
                        </td>
                        <td className="align-middle">
                          {invoice.vendorName ?? "--"}
                        </td>
                        {/* <td className="align-middle">
                          {invoice.createdDate
                            ? new Date(invoice.createdDate).toLocaleDateString(
                              "en-GB"
                            )
                            : "--"}
                        </td> */}
                        {/* <td className="align-middle">
                          {invoice.closureDate
                            ? invoice.closureDate.split(" ")[0].replace(/-/g, "/")
                            : "--"}
                        </td> */}
                        <td className="align-middle">
                          {invoice.invoiceNo ?? "--"}
                        </td>
                        <td className="align-middle">
                          {invoice.invoiceDate
                            ? new Date(invoice.invoiceDate).toLocaleDateString(
                              "en-GB"
                            )
                            : "--"}
                        </td>
                        <td className="align-middle">
                          {invoice.invoiceAmount ?? "--"}
                        </td>
                        {/* <td className="align-middle">
                        ₹{invoice.grossAmount ? parseFloat(invoice.grossAmount).toLocaleString() : "--"}
                      </td> */}
                        <td className="align-middle">
                          ₹{invoice.totalRepairCharges ?? "0"}
                        </td>
                        <td className="align-middle">
                          ₹{invoice.totalServiceCharges ?? "0"}
                        </td>
                        <td className="align-middle">
                          ₹{invoice.gst ?? "0"}
                        </td>
                        <td className="align-middle">
                          {invoice.finalAmount ?? "--"}
                        </td>
                        {/* <td className="align-middle">
                          {invoice.invoice ? (
                            <a
                              href={invoice.invoice}
                              target="_blank"
                              rel="noopener noreferrer"
                              download
                            >
                              <img
                                src={pdfimage}
                                alt="Download PDF"
                                style={{ height: "24px", cursor: "pointer" }}
                              />
                            </a>
                          ) : (
                            "--"
                          )}
                        </td> */}
                        {/* <td className="align-middle">
                          {
                            (!invoice.remarks || invoice.remarks.replace(/,/g, "").trim() === "")
                              ? "N/A"
                              : invoice.remarks
                          }
                        </td> */}
                        {/* <Chip
                          label={invoice.invoiceStatus || "Unknown"}
                          variant="outlined"
                          sx={{
                            color:
                              statusColor[invoice.invoiceStatus?.trim()]?.color || "#6B7280",

                            borderColor:
                              statusColor[invoice.invoiceStatus?.trim()]?.color || "#6B7280",

                            backgroundColor:
                              statusColor[invoice.invoiceStatus?.trim()]?.backgroundColor || "#F3F4F6",

                            "& .MuiChip-label": {
                              color:
                                statusColor[invoice.invoiceStatus?.trim()]?.color || "#6B7280",
                            },
                          }}
                        /> */}
                        <td className="align-middle">
                          <span
                            className="vendore_invoice_status px-3 py-1 rounded-pill"
                            style={{
                              display: "inline-block",
                              border: `1px solid ${invoice.invoiceStatus === "Re-Assigned" ? "#dc3545" : "#0d6efd"
                                }`,
                              color:
                                invoice.invoiceStatus === "Re-Assigned" ? "#dc3545" : "#0d6efd",
                              backgroundColor:
                                invoice.invoiceStatus === "Re-Assigned" ? "#f8d7da" : "#dff6ff",
                              fontWeight: 600,
                              fontSize: "13px",
                            }}
                          >
                            {invoice.invoiceStatus}
                          </span>
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
            <div className="d-flex justify-content-between align-items-center pagination-container network_previous">
              <button
                className="network_previous"
                onClick={handlePrevious}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="page-info">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="network_previous"
                onClick={handleNext}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
        <Search_vendor_popup
          show={showHoldModal}
          handleClose={() => setShowHoldModal(false)}
          vendors={vendorList}
        />
        <style jsx>{`
          .table-container {
            overflow-x: auto;
            width: 100%;
          }
          .network_table {
            min-width: 1200px;
          }
          .network_table th,
          .network_table td {
            padding: 8px;
            vertical-align: middle;
            white-space: nowrap;
          }
          .pagination-container {
            margin-top: 1rem;
          }
          .page-info {
            font-weight: 500;
          }
        `}</style>
      </div>
      <Dialog open={openPopup} onClose={() => setOpenPopup(false)} maxWidth="md" fullWidth>
        <DialogTitle>AA Batch Details</DialogTitle>
        {aaSearchResult && aaSearchResult.length > 0 && (
          <Typography variant="h6" gutterBottom className="mx-4" style={{ textDecoration: "underline", color: "blue" }}>
            Batch No: <strong>{aaSearchResult[0]?.batchNo || "N/A"}</strong>
          </Typography>
        )}
        <DialogContent>
          {aaSearchResult && aaSearchResult.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Customer Name</TableCell>
                  <TableCell>AA No</TableCell>
                  <TableCell>IMEI No</TableCell>
                  <TableCell>Brand</TableCell>
                  <TableCell>Model</TableCell>
                  <TableCell>Service Type</TableCell>
                  <TableCell>Repair Charges</TableCell>
                  <TableCell>Service Charges</TableCell>
                  <TableCell>Invoice No</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {aaSearchResult.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.customerName?.trim()}</TableCell>
                    <TableCell>{item.aaNo}</TableCell>
                    <TableCell>{item.imeiNo}</TableCell>
                    <TableCell>{item.brand?.trim()}</TableCell>
                    <TableCell>{item.makeModel?.trim()}</TableCell>
                    <TableCell>{item.serviceType}</TableCell>
                    <TableCell>{item.repairCharges}</TableCell>
                    <TableCell>{item.serviceCharges}</TableCell>
                    <TableCell>{item.invoiceNo}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Typography>No data found</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPopup(false)}>Close</Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

export default Review_batches;
